import { QuoteChannel } from "@/interfaces/quoter.interface";
import { formatNumber } from "@/utilities/NumberUtils";
import { useTranslation } from "react-i18next";

interface ChannelSelectCardProps {
  type: QuoteChannel;
  currency: string;
  fx: number;
  transferFee: number;
  available?: boolean;
}

export const ChannelSelectCard = ({
  type,
  currency,
  fx,
  transferFee,
  available = true,
}: ChannelSelectCardProps) => {
  const [t] = useTranslation("global");

  if (!available) {
    return (
      <div className="flex flex-col items-center">
        <p className="font-semibold leading-tight text-center">
          {type === QuoteChannel.bestFx
            ? t("Quoter.Channel.BestFx")
            : t("Quoter.Channel.CheaperFee")}
        </p>
        <p className="text-gray-500 text-center text-sm">
          {t("Quoter.Channel.NotAvailable")}
        </p>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center">
      <p className="font-semibold leading-tight text-center">
        {type === QuoteChannel.bestFx
          ? t("Quoter.Channel.BestFx")
          : t("Quoter.Channel.CheaperFee")}
      </p>
      <p className="text-gray-600 font-medium text-center text-sm md:text-base">
        1 USD =
        <span className="text-primary-600">
          {" "}
          {formatNumber(fx, {
            maximumFractionDigits: 4,
            minimumFractionDigits: 4,
          })}{" "}
          {currency}
        </span>
      </p>
      <p className="text-xs text-gray-400 text-center">
        {formatNumber(transferFee)} USD {t("Quoter.Fee")}
      </p>
    </div>
  );
};
